"use client";

import { c as _c } from "react/compiler-runtime";
import GridColumn from "@/components/common/grid-column/grid-column";
import GridRow from "@/components/common/grid-row/grid-row";
import ProductArticleCard from "../products/product/product-articles/product-article-card/product-article-card";
import { mapArticleInfo } from "@/utilities/resources";
import { ArticleData } from "@/sanity/interfaces";
interface IArticlesProps {
  data: ArticleData[];
}
const Articles = props => {
  const $ = _c(3);
  const {
    data
  } = props;
  let t0;
  if ($[0] !== data) {
    const articleInfo = mapArticleInfo(data, "Read Article");
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <GridColumn className="h-[34px] self-stretch text-center md:text-left"><h3 className="h-[34px] self-stretch font-lora text-[28px] font-semibold leading-[34px] tracking-[0.2px] text-[#00698F]">Latest Articles</h3></GridColumn>;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = <GridRow>{t1}{articleInfo.map(_temp)}</GridRow>;
    $[0] = data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default Articles;
function _temp(item, index) {
  return <GridColumn key={index} lg={4}><ProductArticleCard {...item} /></GridColumn>;
}